import React from 'react';
import { Section } from '../Section';
import { Heading2 } from '../Heading2';
import { FadeUp } from '../FadeUp';
import { insideItems } from '../../data/inside';
export function Inside() {
  return <Section data-id="element-157" data-mp="1vvfvh75w98io">
      <FadeUp data-id="element-158" data-mp="1vx0v3b72fhne">
        <Heading2 data-id="element-159" data-mp="1vwhatnty0h67">
          What's <em className="italic" data-id="element-160" data-mp="1vtv75za6alt9">inside</em>?
        </Heading2>

        <ul className="mx-auto mt-10 max-w-[520px] space-y-[18px]" data-id="element-161" data-mp="20tr9zv74w778">
          {insideItems.map(item => <li key={item.lead} className="flex items-start gap-3 text-left text-[16px]" data-id="element-162" data-mp="146ctjy1hca97">
              <span aria-hidden="true" className="flex-none leading-[1.6] text-gain" data-id="element-163" data-mp="1876jsy2ea159">
                ✓
              </span>
              <span data-id="element-164" data-mp="1d3de1tlfho7d">
                <strong className="font-extrabold" data-id="element-165" data-mp="1hw6jyksmv2l1">{item.lead}</strong>
                {item.rest}
              </span>
            </li>)}
        </ul>
      </FadeUp>
    </Section>;
}